(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/before-after-slider"],{

/***/ "./src/assets/js/before-after-slider.js":
/*!**********************************************!*\
  !*** ./src/assets/js/before-after-slider.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BeforeAfterSlider = /*#__PURE__*/function (_HTMLElement) {
  function BeforeAfterSlider() {
    var _this;
    _classCallCheck(this, BeforeAfterSlider);
    _this = _callSuper(this, BeforeAfterSlider);
    _this.topSlider = _this.querySelector('.before-after-slider-top');
    _this.bottomSlider = _this.querySelector('.before-after-slider-bottom');
    _this.topSliderPrev = _this.querySelector('.before-after-slider-top__arrow-prev');
    _this.topSliderNext = _this.querySelector('.before-after-slider-top__arrow-next');
    _this.isMobile = window.innerWidth < 768;
    _this.isManuallyChanging = false;
    return _this;
  }
  _inherits(BeforeAfterSlider, _HTMLElement);
  return _createClass(BeforeAfterSlider, [{
    key: "init",
    value: function init() {
      this.initializeTopSlider();
      this.initializeBottomSlider();
      if (this.isMobile) {
        this.setupMobileSync();
      } else {
        this.setupDesktopSync();
      }
    }
  }, {
    key: "initializeTopSlider",
    value: function initializeTopSlider() {
      var topSlides = this.topSlider.querySelectorAll('.swiper-slide');
      var slidesPerView = 3;
      var totalSlidesRequired = slidesPerView * 2;
      if (topSlides.length < totalSlidesRequired) {
        if (this.activeSliderTop) {
          this.activeSliderTop.destroy(true, true);
        }
        var totalTopSlides = topSlides.length;
        var wrapper = this.topSlider.querySelector('.swiper-wrapper');
        for (var i = 0; i < totalTopSlides; i++) {
          var clone = topSlides[i].cloneNode(true);
          wrapper.appendChild(clone);
        }
      }
      this.activeSliderTop = new Swiper(this.topSlider, {
        slidesPerView: 3,
        loop: true,
        centeredSlides: true,
        preloadSlides: 15,
        loopedSlides: 15,
        spaceBetween: 18,
        watchSlidesProgress: true,
        navigation: {
          nextEl: this.topSliderNext,
          prevEl: this.topSliderPrev
        },
        breakpoints: {
          1024: {
            centeredSlides: false
          }
        }
      });
    }
  }, {
    key: "initializeBottomSlider",
    value: function initializeBottomSlider() {
      var topSlidesCount = this.topSlider.querySelectorAll('.swiper-slide').length;
      var bottomSlides = this.bottomSlider.querySelectorAll('.swiper-slide');
      if (bottomSlides.length < topSlidesCount) {
        if (this.activeSliderBottom) {
          this.activeSliderBottom.destroy(true, true);
        }
        var totalBottomSlides = bottomSlides.length;
        var wrapper = this.bottomSlider.querySelector('.swiper-wrapper');
        for (var i = 0; i < topSlidesCount - totalBottomSlides; i++) {
          var clone = bottomSlides[i % totalBottomSlides].cloneNode(true);
          wrapper.appendChild(clone);
        }
      }
      this.activeSliderBottom = new Swiper(this.bottomSlider, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        allowTouchMove: true,
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      });
    }
  }, {
    key: "setupDesktopSync",
    value: function setupDesktopSync() {
      this.activeSliderTop.controller.control = this.activeSliderBottom;
      this.activeSliderBottom.controller.control = this.activeSliderTop;
      this.onTopSliderClick();
    }
  }, {
    key: "setupMobileSync",
    value: function setupMobileSync() {
      var _this2 = this;
      this.activeSliderTop.on('slideChange', function () {
        if (!_this2.isManuallyChanging) {
          _this2.isManuallyChanging = true;
          _this2.activeSliderBottom.slideTo(_this2.activeSliderTop.realIndex);
          _this2.isManuallyChanging = false;
        }
      });
      this.activeSliderBottom.on('slideChange', function () {
        if (!_this2.isManuallyChanging) {
          _this2.isManuallyChanging = true;
          var syncedIndex = _this2.activeSliderBottom.realIndex;
          _this2.activeSliderTop.slideToLoop(syncedIndex);
          _this2.isManuallyChanging = false;
        }
      });
      this.onTopSliderClick();
    }
  }, {
    key: "onTopSliderClick",
    value: function onTopSliderClick() {
      var _this3 = this;
      var topSlides = this.topSlider.querySelectorAll('.swiper-slide');
      topSlides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          if (!_this3.isManuallyChanging) {
            _this3.isManuallyChanging = true;
            var clickedIndex = parseInt(slide.dataset.swiperSlideIndex, 10);
            _this3.activeSliderTop.slideToLoop(clickedIndex);
            _this3.activeSliderBottom.slideTo(clickedIndex);
            _this3.isManuallyChanging = false;
          }
        });
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      document.addEventListener('DOMContentLoaded', function () {
        var checkSwiper = setInterval(function () {
          if (typeof Swiper !== 'undefined') {
            _this4.init();
            clearInterval(checkSwiper);
          }
        }, 100);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('before-after-slider')) {
  customElements.define('before-after-slider', BeforeAfterSlider);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/before-after-slider.js"));
/******/ }
]);